import React, { useEffect, useState } from "react";
import dataProvider from "../../../providers/dataProvider";
import { PreviewFeaturedCompetitionsTable } from "./previewTable";

export interface PreviewFeaturedCompetition {
  _id: string;
  title: string;
  competitionType: string;
  isTrending: boolean;
}
export interface PreviewTabFeatureCompetitionsState {
  page: number;
  perPage: number;
  allCount: number;
  competitions: Array<PreviewFeaturedCompetition>;
}
export interface GetCompetitionsAsyncParams {
  page: number;
  perPage: number;
  searchTitle: string;
  searchCompetitionType: Array<string>;
}

export const PreviewTabFeatureCompetitions = ({
  getGeneralFeturedCompetitions,
}) => {
  const [state, setState] = useState<PreviewTabFeatureCompetitionsState>({
    page: 1,
    perPage: 10,
    allCount: 0,
    competitions: Array<PreviewFeaturedCompetition>(),
  });

  const [searchState, setSearchState] = useState({
    title: "",
  });

  const [filter, setFilter] = useState({
    searchCompetitionType: Array<string>(),
    searchField:''
  });

  const getGeneralFeturedCompetitionsAsync = async ({
    page,
    perPage,
    searchTitle,
    searchCompetitionType,
  }: GetCompetitionsAsyncParams) => {
    const competitions = await dataProvider.getAllFeaturedCompetitions({
      filter: {
        searchTitle,
        competitionTypes: searchCompetitionType,
      },
      pagination: { page: page, perPage: perPage },
    });
    setState({
      ...state,
      allCount: competitions.data.allCount,
      competitions: competitions.data.result,
      page: page,
      perPage: perPage,
    });
  };

  const handleChangeIsTrending = async (
    competition: PreviewFeaturedCompetition
  ) => {
    competition.isTrending = !competition.isTrending;
    if (competition.isTrending) {
      await dataProvider.addFeatured(
        competition.competitionType,
        competition._id
      );
    } else {
      await dataProvider.removeFeatured(
        competition.competitionType,
        competition._id
      );
    }

    getGeneralFeturedCompetitionsAsync({
      page: state.page,
      perPage: state.perPage,
      searchTitle: searchState.title,
      searchCompetitionType: filter.searchCompetitionType,
    });
    getGeneralFeturedCompetitions();
  };

  useEffect(() => {
    getGeneralFeturedCompetitionsAsync({
      page: state.page,
      perPage: state.perPage,
      searchTitle: searchState.title,
      searchCompetitionType: filter.searchCompetitionType,
    });
  }, []);

  return (
    <PreviewFeaturedCompetitionsTable
      getGeneralFeturedCompetitionsAsync={getGeneralFeturedCompetitionsAsync}
      handleChangeIsTrending={handleChangeIsTrending}
      state={state}
      searchState={searchState}
      filterState={filter}
      setFilter={setFilter}
      setSearch={setSearchState}
    />
  );
};
